var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('screen-header', {
          attrs: {
            "title": _vm.displayTitle
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', [_c('navigate-button', {
          directives: [{
            name: "absolute",
            rawName: "v-absolute"
          }, {
            name: "left",
            rawName: "v-left",
            value: -80,
            expression: "-80"
          }],
          on: {
            "navigate": function navigate($event) {
              return _vm.$router.go(-1);
            }
          }
        }), _c('screen-title', {
          attrs: {
            "title": _vm.displayTitle
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c('report-builder-form', {
    attrs: {
      "metrics": _vm.metrics,
      "partners": _vm.getChildProjects
    },
    model: {
      value: _vm.formData,
      callback: function callback($$v) {
        _vm.formData = $$v;
      },
      expression: "formData"
    }
  }, [_c('masked-input', {
    attrs: {
      "slot": "period",
      "mask": _vm.periodPatternMask,
      "label": _vm.$t('unloading.period'),
      "placeholder": _vm.$t('enter.period')
    },
    on: {
      "change": _vm.parseUploadingPeriod
    },
    slot: "period",
    model: {
      value: _vm.unloadingPeriod,
      callback: function callback($$v) {
        _vm.unloadingPeriod = $$v;
      },
      expression: "unloadingPeriod"
    }
  }, [_c('div', {
    class: _vm.$style.link,
    attrs: {
      "slot": "link"
    },
    on: {
      "click": _vm.handleShownDateRange
    },
    slot: "link"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.choose')) + " ")])])], 1), _c('div', {
    class: _vm.$style.building
  }, [_c('link-button', {
    attrs: {
      "href": "/report/download?".concat(_vm.getSerializedQuery),
      "disabled": _vm.disableSubmit,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('get.report')) + " ")])], 1), _c('div', {
    class: _vm.$style.saving
  }, [_c('cs-button', {
    attrs: {
      "width": "250px",
      "type": "secondary",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": _vm.handleManagingTemplate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('save.template')) + " ")])], 1), _c('selecting-transaction-types'), _c('selecting-transaction-statuses'), _c('selecting-date-range'), _c('selecting-period-preset'), _c('selecting-report-metrics', {
    attrs: {
      "metrics": _vm.metrics,
      "report-type": _vm.reportType
    }
  }), _c('selecting-partners', {
    attrs: {
      "partners": _vm.getChildProjects
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }